import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from '../common/ErrorFallback'
import { LoaderProvider } from '../context/FormLoader'
import InteractiveTemplateMain from './InteractiveTemplateMain'
import InteractiveTemplatesLeftHandNavigationMenu from './InteractiveTemplatesLeftHandNavigationMenu'

const FormsLanding = () => {
  return (
    <Suspense fallback={null}>
      <LoaderProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <div className="content-wrapper content-article two-column">
            <InteractiveTemplatesLeftHandNavigationMenu />
            <article className="main rightWider" role="main">
              <InteractiveTemplateMain />
            </article>
          </div>
        </ErrorBoundary>
      </LoaderProvider>
    </Suspense>
  )
}

export default FormsLanding
